module.exports = __webpack_public_path__ + "static/react-github-stats-a0c3a2af7c40ffc92b33872680dfe9d2.png";